import BlogThirtySixContainer from "./container/BlogThirtySixContainer";
export default BlogThirtySixContainer;
